module.exports = __webpack_public_path__ + "img/hik.306d209e.svg";